var lang_1 = require("../../facade/lang");
// This will be needed when we will used Reflect APIs
/*const Reflect = global.Reflect;
 if (!(Reflect && Reflect.getMetadata)) {
 throw 'reflect-metadata shim is required when using class decorators';
 }*/
/**
 * @internal
 * @private
 * @type {string}
 */
exports.CLASS_META_KEY = '__mAnnotations';
/**
 * @internal
 * @private
 * @type {string}
 */
exports.PARAM_META_KEY = '__mParameters';
/**
 * @internal
 * @private
 * @type {string}
 */
exports.PROP_META_KEY = '__mPropMetadata';
/**
 * Provides access to reflection data about symbols. Used internally by Angular
 * to power dependency injection and compilation.
 */
var Reflector = (function () {
    function Reflector() {
    }
    Reflector.prototype.parameters = function (typeOrFunc) {
        //return Reflect.getMetadata('parameters', cls);
        return extractParameter(typeOrFunc) || [];
    };
    Reflector.prototype.registerParameters = function (parameters, type) {
        //Reflect.defineMetadata('parameters', parameters, cls);
        type[exports.PARAM_META_KEY] = parameters;
    };
    Reflector.prototype.annotations = function (typeOrFunc) {
        //return Reflect.getOwnMetadata('annotations', cls);
        return extractAnnotation(typeOrFunc) || [];
    };
    Reflector.prototype.registerAnnotation = function (annotations, type) {
        //Reflect.defineMetadata('annotations', annotations, cls);
        type[exports.CLASS_META_KEY] = annotations;
    };
    Reflector.prototype.propMetadata = function (typeOrFunc) {
        //return Reflect.getOwnMetadata('propMetadata', target.constructor);
        return extractProperty(typeOrFunc) || {};
    };
    Reflector.prototype.registerPropMetadata = function (propMetadata, type) {
        //Reflect.defineMetadata('propMetadata', meta, target);
        type[exports.PROP_META_KEY] = propMetadata;
    };
    return Reflector;
})();
exports.Reflector = Reflector;
function extract(metaKey) {
    return function (cls) {
        if (lang_1.isFunction(cls) && cls.hasOwnProperty(metaKey)) {
            // it is a decorator, extract annotation
            return cls[metaKey];
        }
    };
}
function extractAnnotation(cls) {
    return extract(exports.CLASS_META_KEY)(cls);
}
function extractParameter(cls) {
    return extract(exports.PARAM_META_KEY)(cls);
}
function extractProperty(cls) {
    return extract(exports.PROP_META_KEY)(cls);
}
//# sourceMappingURL=reflector.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/ng-metadata/src/core/reflection/reflector.js
 ** module id = 47
 ** module chunks = 0
 **/